import { AccessGuids, ConfigSystemParams,msSize } from 'src/app/core/consts';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { CommunicationDeliveryResultDTO } from 'src/app/core/models/system/communication/communication-delivery-result.dto';
import { CommunicationDTO } from 'src/app/core/models/system/communication/communication.dto';
import { CommunicationService } from 'src/app/core/services/utelize/system/communication/communication-service';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompletedModalFormComponent } from '../../_pop-ups/completed-modal-form/completed-modal-form.component';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OurDate } from 'src/app/core/interfaces/general/our-date';
import { populateOurDate } from 'src/app/core/functions-generic/functions-generic-date';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TypesCommunicationService } from 'src/app/core/services/utelize/system/type/types-communication-service';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';
import { WarningModalFormComponent } from '../../_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-communication-modal-form',
  templateUrl: './communication-modal-form.component.html',
  styleUrls: ['./communication-modal-form.component.scss']
})

export class CommunicationModalFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Input() initialMessage         : string | undefined;
  @Input() initialSubject         : string | undefined;
  @Input() initialSureSimCompanyId: number | undefined;
  @Input() initialSureSimUserId   : number | undefined;

  @Output() dataHasBeenSaved: EventEmitter<any                                  >=new EventEmitter<any>();
  @Output() formCancelled   : EventEmitter<void                                 >=new EventEmitter<void>();
  @Output() openReplyModal  : EventEmitter<{ companyId: number, userId: number }>=new EventEmitter();
  
  @ViewChild('communicationModalForm', { static: false }) communicationModalForm!: TemplateRef<void>;
  @ViewChild('completedModalForm',     { static: false }) completedModalForm!    : CompletedModalFormComponent;
  @ViewChild('warningModalForm',       { static: false }) warningModalForm!      : WarningModalFormComponent;
                          
  get canMessageBaseWide() { return this.componentAccessUserService.hasAccessGuid(AccessGuids.FormCommunicationMessageBaseWide, true); }
  
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }

  get communicationTypeDescription(): string {
    try {
      const typeId=this.communication?.communicationTypeID;
      const match =(this.communicationTypeIdData ?? []).find(t => t.id===typeId);

      return match?.description ?? "";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  private communicationId           : number | undefined;
  private communicationModalFormRef!: NgbModalRef;
  private communicationTypeIdData!  : IdAndDescriptionDTO[];
  private companyIdData!            : IdAndDescriptionDTO[];
  private newCommunication          : boolean=false;
  private userIdData!               : IdAndDescriptionDTO[];
  
  public communication          : CommunicationDTO | undefined;
  public communicationForm!     : UntypedFormGroup;
  public curUser                : SystemUserDTO;
  public deliveryResults        : CommunicationDeliveryResultDTO[]=[];
  public endDate                : OurDate | undefined;
  public enteredByCompanyId     : number | undefined;
  public formTitle              : string="Communicator";
  public formSubmitted          : boolean=false;
  public gotInitialCompanyOrUser: boolean=false;
  public isLegacySms            : boolean=false;
  public messageRead            : boolean=false;
  public readonly               : boolean=false;
  public showReplyIcon          : boolean=false;
  public startDate              : OurDate | undefined=populateOurDate(this.exceptionsService, Date.now());
  public toCompanies            : string[]=[];
  public toEmails               : string[]=[];
  
  //#region for Validators
  
  public subjectMaxLength: number=200;
  
  //#endregion  

  constructor(
    private authenticationService     : AuthenticationService,
    private communicationService      : CommunicationService,
    private companiesService          : CompaniesService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private exceptionsService         : ExceptionsService,
    private formBuilder               : UntypedFormBuilder,
    private lastPassKillerService     : LastPassKillerService,
    private modalService              : NgbModal,
    private typesCommunicationService : TypesCommunicationService,
    private usersService              : UsersService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetMainVariables(): void {
    try {
      this.communication          =undefined;
      this.communicationId        =undefined;
      this.deliveryResults        =[];
      this.endDate                =undefined;
      this.enteredByCompanyId     =undefined;
      this.formSubmitted          =false;
      this.gotInitialCompanyOrUser=((this.initialSureSimCompanyId != undefined && this.initialSureSimCompanyId>0) ||
                                    (this.initialSureSimUserId    != undefined && this.initialSureSimUserId   >0));
      this.isLegacySms            =false;
      this.newCommunication       =false;
      this.readonly               =false;
      this.showReplyIcon          =this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCommunicationShowReplyIcon);
      this.startDate              =populateOurDate(this.exceptionsService, Date.now());
      this.toCompanies            =[];
      this.toEmails               =[];
      this.userIdData             =[];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(communicationId: number, readonly: boolean, toEmails?: string, toCompanies?: string): void {
    try {
      this.resetMainVariables();

      this.readonly   =readonly;
      this.formTitle  =readonly ? "Received Message" : "Communicator";
      this.toCompanies=this.splitAndSortRecipients(toCompanies);
      this.toEmails   =this.splitAndSortRecipients(toEmails);

      this.refreshCommunicationTypeData();

      if (!this.readonly)
        this.refreshCompanyData();

      this.setUpForm();

      this.readonly ?  this.communicationForm.get('communicationTypeId')?.disable() : this.communicationForm.get('communicationTypeId')?.enable();

      this.initialSureSimCompanyId != undefined && this.initialSureSimCompanyId>0 ? this.communicationForm.get('companyId')?.disable()
                                                                                  : this.communicationForm.get('companyId')?.enable();

      this.initialSureSimUserId != undefined && this.initialSureSimUserId>0 ? this.communicationForm.get('userId')?.disable()
                                                                            : this.communicationForm.get('userId')?.enable();

      
      
      if (communicationId != undefined && <number>communicationId>0) {
        this.newCommunication=false;
        this.communicationId =communicationId;
        this.getCommunication();
        this.markAsRead();

      } else {
        this.newCommunication=true;
        this.communicationId =0;
        this.openModal();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openFormFromData(communication: CommunicationDTO, toEmails?: string, toCompanies?: string): void {
    try {
      this.resetMainVariables();

      this.isLegacySms=true;
      this.readonly   =true;
      this.formTitle  ="Received Message";
      this.toCompanies=this.splitAndSortRecipients(toCompanies);
      this.toEmails   =this.splitAndSortRecipients(toEmails);

      this.communication  =communication;
      this.communicationId=0;
      this.newCommunication=false;

      this.refreshCommunicationTypeData();
      this.setUpForm();
      this.communicationForm.get('communicationTypeId')?.disable();

      this.openModal();
      this.populateFormFields(this.communicationForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private splitAndSortRecipients(value: string | undefined): string[] {
    try {
      if (value==undefined || value.trim()=="")
        return [];

      return value
             .split(/[,;]/)
             .map(entry => entry.trim())
             .filter(entry => entry!="")
             .sort((a, b) => a.localeCompare(b));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private openModal(): void {
    try {
      this.communicationModalFormRef=this.modalService.open(this.communicationModalForm, { backdrop: this.modalBackGround,
                                                                                           centered: true,
                                                                                           keyboard: false,
                                                                                           size    : msSize.Large });
    }
    catch(e) {
      this.formCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region communicationForm

  get formOfCommunication() {
    return this.communicationForm.controls;
  }

  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.communicationForm);

      this.communicationForm=this.formBuilder.group({ });
      
      this.addFormFields(this.communicationForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.communicationForm) {
        this.addFormControl(formGroup, "active",              true,                         []);
        this.addFormControl(formGroup, "communicationTypeId", undefined,                    [Validators.required]);
        this.addFormControl(formGroup, "companyId",           this.initialSureSimCompanyId, this.canMessageBaseWide ? [] : [Validators.required]);
        this.addFormControl(formGroup, "endDate",             undefined,                    []);
        this.addFormControl(formGroup, "message",             this.initialMessage,          [Validators.required]);
        this.addFormControl(formGroup, "read",                false,                        []);
        this.addFormControl(formGroup, "startDate",           this.startDate?.date,         [Validators.required]);
        this.addFormControl(formGroup, "subject",             this.initialSubject,          [Validators.required, Validators.maxLength(this.subjectMaxLength)]);
        this.addFormControl(formGroup, "userId",              undefined,                    []);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | Date | number | string | undefined,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private populateFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.communicationForm && this.communication != undefined) {
        this.communicationForm.controls["active"].setValue(this.communication.active);
        this.communicationForm.controls["communicationTypeId"].setValue(this.communication.communicationTypeID);
        this.communicationForm.controls["companyId"].setValue(this.communication.companyID);
        this.communicationForm.controls["endDate"].setValue(this.communication.endDate);
        this.communicationForm.controls["message"].setValue(this.communication.message);
        this.communicationForm.controls["startDate"].setValue(this.communication.startDate);
        this.communicationForm.controls["subject"].setValue(this.communication.subject);
        this.communicationForm.controls["userId"].setValue(this.communication.userID);

        this.startDate=populateOurDate(this.exceptionsService, this.communication.startDate);

        if (this.communication.endDate)
          this.endDate=populateOurDate(this.exceptionsService, this.communication.endDate);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private enableDisableControls(enabled: boolean) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public communicationFormSubmit() {
    try {
      this.formSubmitted=true;

      if (this.communicationForm.valid) {
        this.prepareToSaveCommunication();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public communicationFormCancel() {
    try {
      this.formCancelled.emit();
      this.communicationModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
    
  public companySelectDropDownChange(ev: any) {
    try {
      this.refreshUserData();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public startDateChanged(startDate: OurDate) {
    try {
      this.startDate=startDate;

      this.communicationForm.controls["startDate"].setValue(this.startDate.date);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public endDateChanged(endDate: OurDate) {
    try {
      this.endDate=endDate;

      this.communicationForm.controls["endDate"].setValue(this.endDate.date);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Dropdown Arrays

  public getDropdownDataObjectArray(fieldName: string) {
    try {
      if (fieldName=="communicationTypeId") {
        return this.communicationTypeIdData;

      } else if (fieldName=="companyId") {
        return this.companyIdData;

      } else if (fieldName=="userId") {
        return this.userIdData;

      }
      
      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="communicationTypeId") {
              this.communicationTypeIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="companyId") {
              this.companyIdData=(data as IdAndDescriptionDTO[]);

              if ((this.initialSureSimCompanyId && this.initialSureSimCompanyId>0) ||
                  (this.communicationForm.controls["companyId"].value ?? 0)>0) {
                this.refreshUserData();
              }

            } else if (fieldName=="userId") {
              this.userIdData=(data as IdAndDescriptionDTO[]);

              if (this.initialSureSimUserId && this.initialSureSimUserId>0) {
                this.communicationForm.controls["userId"].setValue(this.initialSureSimUserId);
              }
              else if ((this.communication?.userID ?? 0)>0) {
                this.communicationForm.controls["userId"].setValue(this.communication?.userID);
              }
            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Refresh Dropdown Arrays Data

  public refreshCommunicationTypeData() {
    try {
      this.getDropdownData(this.typesCommunicationService.getIdAndDescription(), "communicationTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshCompanyData() {
    try {
      this.getDropdownData(this.companiesService.getIdAndDescriptionForLoggedInUser(this.curUser.userId), "companyId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshUserData() {
    try {
      const companyId: number=this.communicationForm.controls["companyId"].value ?? 0;

      if (companyId<=0) {
        this.userIdData=[];
        return;
      }

      this.getDropdownData(this.usersService.getIdAndDescriptionByCompanyId(companyId), "userId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion

  //#region Communication
    
  public getCommunication() {
    try {
      this.communicationService.getById(<number>this.communicationId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.communication=data;

          if (this.readonly) {
            this.getEnteredByCompanyId();
            this.getDeliveryResults();
          }

          this.openModal();
          this.populateFormFields(this.communicationForm);

          if (!this.readonly)
            this.refreshUserData();
        },
        error: error => {
          this.formCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getDeliveryResults() {
    try {
      this.communicationService.getDeliveryResults(<number>this.communicationId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.deliveryResults=data ?? [];
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public deliveryStatusClass(status: string | undefined): string {
    try {
      switch ((status ?? "").toLowerCase()) {
        case "failed":
          return "text-danger";

        case "delivered":
        case "sent":
          return "text-success";

        case "queued":
          return "text-warning";

        case "read":
          return "text-info";
          
        default:
          return "";
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  private prepareToSaveCommunication() {
    try {
      this.communication={
        active             : this.communicationForm.controls["active"].value,
        communicationTypeID: this.communicationForm.controls["communicationTypeId"].value,
        companyID          : this.communicationForm.controls["companyId"].value,
        endDate            : this.communicationForm.controls["endDate"].value,
        enteredBy          : this.curUser.userId,
        id                 : this.communicationId && this.communicationId>0 ? this.communicationId : 0,
        message            : this.communicationForm.controls["message"].value,
        startDate          : this.communicationForm.controls["startDate"].value,
        subject            : this.communicationForm.controls["subject"].value,
        userID             : this.communicationForm.controls["userId"].value
      };

      this.saveCommunication(this.communication!)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          if (this.newCommunication) {
            this.communication!.id=data["id"];
            this.communicationId  =data["id"];
          }

          this.processComplete();

          this.dataHasBeenSaved.emit(this.communicationId);
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private saveCommunication(communication: CommunicationDTO): Observable<CommunicationDTO> {
    return this.communicationService.save(communication);
  }

  //#endregion
    
  public getEnteredByCompanyId() {
    try {
      this.usersService.getCompanyId(this.communication?.enteredBy ?? -1)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.enteredByCompanyId=data.result;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Process Complete

  private processComplete() {
    try {
      this.completedModalForm.openForm(this.newCommunication ? "Notification Created" : "Notification Details Updated", "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalHasBeenClosed() {
    try {
      this.communicationModalFormRef.close();
      this.dataHasBeenSaved.emit(undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Mark as Read or Unread

  public readOrUnreadClick() {
    try {
      this.messageRead=!this.communicationForm.get('read')?.value;

      if (this.messageRead) {
        this.markAsRead();

      } else {
        this.markAsUnread();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public markAsRead() {
    try {
      this.communicationService.markAsRead(this.curUser.userId, this.curUser.userId, <number>this.communicationId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.messageRead=true;
          this.communicationForm.controls["read"].setValue(true);
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public markAsUnread() {
    try {
      this.communicationService.markAsUnread(this.curUser.userId, <number>this.communicationId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.messageRead=false;
          this.communicationForm.controls["read"].setValue(false);
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Reply Message
  
  public replyMessageClick() {
    try {
      this.openReplyModal.emit({
        companyId: this.enteredByCompanyId ?? -1,
        userId   : this.communication?.enteredBy ?? -1
      });

      this.communicationFormCancel();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
